import * as XLSX from 'xlsx';

const DownloadChallanReportExcel = (reportData, companyName, setOpenBackdrop) => {
    if (!reportData || reportData.length === 0) {
        alert("No data found to generate excel!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];

        // Formatting data for Excel (Flattening the nested structure)
        reportData.forEach((customer) => {
            customer.challans.forEach((challan) => {
                challan.items.forEach((item, index) => {
                    rows.push({
                        "Customer Name": customer.fname,
                        "Customer Code": customer.customer_code,
                        "Mobile": customer.mobile,
                        "Challan No": challan.challan_no,
                        "Challan Date": challan.challan_date,
                        "S.No": index + 1,
                        "Item Name": item.itemname,
                        "Quantity": Number(item.qty),
                        "Rate": Number(item.rate),
                        "Amount": Number(item.amount),
                        "Challan Total": index === 0 ? Number(challan.total_amount) : "" // Pehli row pe total dikhayega
                    });
                });
            });
        });

        // Create Worksheet
        const worksheet = XLSX.utils.json_to_sheet(rows);

        // Column Widths Set Karein (Professional Look)
        const wscols = [
            { wch: 25 }, // Customer Name
            { wch: 15 }, // Customer Code
            { wch: 15 }, // Mobile
            { wch: 15 }, // Challan No
            { wch: 20 }, // Challan Date
            { wch: 5 },  // S.No
            { wch: 30 }, // Item Name
            { wch: 10 }, // Qty
            { wch: 10 }, // Rate
            { wch: 12 }, // Amount
            { wch: 15 }, // Challan Total
        ];
        worksheet['!cols'] = wscols;

        // Create Workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Challan Report");

        // Save File
        const timestamp = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `${companyName}_Challan_Report_${timestamp}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        alert("Error generating Excel report");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadChallanReportExcel;